var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterIconAqua(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.077413 1.64926C0.213962 1.35496 0.508906 1.16666 0.833344 1.16666H14.1667C14.4911 1.16666 14.7861 1.35496 14.9226 1.64926C15.0592 1.94356 15.0125 2.29036 14.803 2.53809L9.66668 8.61178V14C9.66668 14.2888 9.51713 14.557 9.27145 14.7089C9.02577 14.8607 8.71899 14.8745 8.46067 14.7453L5.794 13.412C5.51168 13.2709 5.33334 12.9823 5.33334 12.6667V8.61178L0.197036 2.53809C-0.0124618 2.29036 -0.0591356 1.94356 0.077413 1.64926ZM2.62943 2.83332L6.80299 7.76855C6.93021 7.91899 7.00001 8.10964 7.00001 8.30666V12.1516L8.00001 12.6516V8.30666C8.00001 8.10964 8.06982 7.91899 8.19704 7.76855L12.3706 2.83332H2.62943Z",
    fill: "#00ADF0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIconAqua);
export default __webpack_public_path__ + "static/media/filter-icon-aqua.d58357e44efcf749f7dbe31f5aae865e.svg";
export { ForwardRef as ReactComponent };